export const appHead = {"meta":[{"charset":"utf-8"},{"id":"viewport","name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=2, shrink-to-fit=no"}],"link":[{"rel":"icon","type":"image/svg+xml","href":"/logo.svg"},{"rel":"icon","type":"image/svg","href":"/logo.svg"},{"rel":"icon","type":"image/png","href":"/logo.png"}],"style":[],"script":[{"innerHTML":"\n                        // Setup dataLayer\n                        window.dataLayer = window.dataLayer || [];\n                        function gtag(){dataLayer.push(arguments);}\n                        gtag('js', new Date());\n                        \n                        // Define debug mode based on environment\n                        // To disable debug in production, set FORCE_DEBUG_MODE to false in composables/useDebugMode.ts\n                        const isDevMode = true; // Force debug in all environments temporarily\n                        \n                        // Conditional debug log function\n                        const debugLog = function(message) {\n                            if (isDevMode) {\n                                console.log(message);\n                            }\n                        };\n                        \n                        // Define initRedlikeGA4 function directly in the script\n                        window.initRedlikeGA4 = function() {\n                            debugLog('Direct initRedlikeGA4 function called');\n                            if (window.gtag) {\n                                const ga4Id = 'G-H7BGV8HHQ3';\n                                debugLog('GA4 ID: ' + ga4Id);\n                                \n                                window.gtag('get', ga4Id, 'client_id', function(client_id) {\n                                    debugLog('Client ID retrieved: ' + client_id);\n                                    // Store client_id in window for easy access\n                                    window._ga4ClientId = client_id;\n                                });\n                            } else {\n                                if (isDevMode) {\n                                    console.error('gtag function not available');\n                                }\n                            }\n                        };\n                        \n                        // Initialize GTM\n                        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n                        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n                        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n                        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n                        })(window,document,'script','dataLayer','GTM-WRTRK6JR');\n                        \n                        // After 3 seconds, check if gtag exists and call our function\n                        setTimeout(function() {\n                            if (window.gtag && typeof window.gtag === 'function') {\n                                debugLog('Calling initRedlikeGA4 after GTM load');\n                                window.initRedlikeGA4();\n                            } else {\n                                if (isDevMode) {\n                                    console.error('GTM failed to initialize properly');\n                                }\n                            }\n                        }, 3000);\n                    "}],"noscript":[],"title":"Redlike"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = false

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = true

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true